import { factory } from '../../helpers/general';
import {
  LiteCollection,
  OTP,
  RawOTP,
  RawSubscription,
  Subscription,
} from './collections.domain';
import {
  LiteWorkout,
  RawWorkout,
  FixedTitle,
} from '../collection/workouts/workouts.domain';
import { CollectionProgram } from '../../../components/collections/collections.types';

export const rawSubscription = factory<RawSubscription>({
  id: 1,
  isVisible: true,
  influencerId: 1,
  name: 'name',
  color: 'color',
  type: 1,
  publishingBehaviour: 'publishingBehaviour',
  workoutLimit: 1,
  accessType: 'accessType',
  contentStructure: 'contentStructure',
  isLocked: true,
});

export const rawPurchase = factory<RawOTP>({
  id: 1,
  isVisible: true,
  influencerId: 1,
  name: 'name',
  color: 'color',
  type: 1,
  publishingBehaviour: 'publishingBehaviour',
  workoutLimit: 1,
  accessType: 'accessType',
  contentStructure: 'contentStructure',
  isLocked: true,
});

export const subscription = factory<Subscription>({
  ...rawSubscription({}),
  customURL: '',
});

export const otp = factory<OTP>({
  ...rawPurchase({}),
  customURL: '',
});

export const liteCollection = factory<LiteCollection>({
  begins: 0,
  comments: 0,
  isVisible: false,
  isLocked: false,
  rating: 0,
  completions: 0,
  title: 'Test Program',
  programId: 108,
  thumbnailUrl: '',
  type: 'published',
  customURL: '#',
  salesPageUrl:
    'https://my.integration.playbookapp.io/#/programs/test-program/108',
  index: undefined,
  profileDeepLink: 'test',
  accessType: 'exclusive',
  deeplinkUrl: undefined,
  hasChallenges: false,
  hasOngoingChallenges: false,
  challengeDeeplinkURL: 'challengeDeeplinkURL',
  migrationBundleId: null,
});

export const rawWorkout = factory<RawWorkout>({
  __typename: 'WorkoutTiny',
  name: 'name',
  id: 1,
  statsRatingAverage: null,
  statsComments: null,
  statsBegins: null,
  statsCompletions: null,
});

export const liteWorkout = factory<LiteWorkout>({
  workoutId: 1,
  programId: 2,
  programIndex: null,
  fixedTitle: 'Workout 1' as FixedTitle,
  orgTitle: 'Workout 1',
  type: 'draft',
  lastEditedDate: '2021-06-01T08:00:00.000Z',
  scheduledDate: '2021-06-01T08:00:00.000Z',
  freeSample: false,
  rating: 3,
  begins: 1,
  completions: 1,
  comments: 1,
});

type MediaIntro = CollectionProgram['mediaIntro'];
const media = factory<MediaIntro>({
  audio: null,
  cdn01: 'https://d2crdjgereq3ox.cloudfront.net/',
  image: '1685446317207_Screenshot 2023-05-29 at 21.05.05-comp.png',
  video: 'video',
  width: 874,
  height: 870,
  mimeType: 'image/png',
  source: 'https://fitner-uploads-int.s3.amazonaws.com/',
});

export const program = factory<CollectionProgram>({
  accessType: 'exclusive',
  archivedAt: null,
  color: '6367ef',
  contentStructure: 'sequential',
  daysPerWeek: 1,
  description: '',
  difficulty: undefined,
  duration: [5, 'weeks'],
  expiresAt: null,
  faq: [],
  goal: 'Weight Loss',
  hiddenSections: {},
  id: 9394,
  inAppPurchase: 'hide',
  index: 0,
  influencerId: 4342,
  isLocked: false,
  isVisible: false,
  mediaCover: media(),
  name: 'test',
  publishingBehaviour: 'bottom',
  requiredEquipment: [],
  sessionDuration: '<30',
  tags: [],
  targetArea: [],
  testimonials: [],
  type: 0,
  mediaIntro: media(),
  publishedAt: '',
});
